import {inject, Injectable} from '@angular/core';
import {BaseModalApiService} from "../../../../../../../core/components/modals/services/base-modal-api.service";
import {RecordData} from "../../../../../../../core/types/records-table.types";
import {CreateComponentData} from "../types/create-component.types";
import {componentResourceType} from "../configs/create-component-config";

@Injectable({
  providedIn: 'root'
})
export class CreateComponentService {
  private baseModalApiService: BaseModalApiService = inject(BaseModalApiService);

  public createComponentData(params: CreateComponentData): Promise<RecordData> {
    return new Promise((resolve, reject) => {
      this.baseModalApiService.createDataInModal<CreateComponentData, RecordData>(params, componentResourceType.path).subscribe({
        next: (data) => resolve(data),
        error: (error) => reject(error)
      });
    });
  }
}
